import { getDateStr } from "../../utils/getDateStr";

export const DateCell = (props) => {
  let str = getDateStr(props.date);

  return (
    <td>{str}</td>
  )
}